module.exports = __webpack_public_path__ + "static/media/deleteLoc.83d27221.png";